<template>
  <h5 class="font-weight-bold white--text text-h5 text-sm-h5 mb-10">{{ titulo }}</h5>
</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
      required: true,
    },
  },
};
</script>

<style></style>
